import { useTranslation } from 'react-i18next';
import { BiSolidNote } from 'react-icons/bi';

import { PSButton } from '@/components/ui/button';
// import { v4 as uuidv4 } from "uuid";
// import { useAppSelector } from "../../../app/hook";
// import { selectUseId } from "../../../features/auth/auth.slice";

const AddNoteButton = ({ noteFormMethods }: { noteFormMethods: any }) => {
  //const userId = useAppSelector(selectUseId);
  const { t } = useTranslation();
  const { setValue, getValues } = noteFormMethods;

  return (
    <PSButton
      id="btn-show-note-form"
      variant="info"
      type="button"
      // disabled={!currentId && getValues("showNoteForm")}
      onClick={() => {
        setValue('showNoteForm', !getValues('showNoteForm'));
        // append({
        //   note_id: uuidv4(),
        //   creation_date_time: new Date().toISOString(),
        //   title: "",
        //   description: "",
        //   qc: true,
        //   author: userId
        // });
      }}
      icon={<BiSolidNote className="tw-w-6 tw-h-6 tw-relative  tw-overflow-hidden text-black" />}
      role="button"
      className="tw-border-solid tw-h-11 tw-pl-3 tw-pr-4 tw-py-2.5 tw-bg-white tw-rounded-full tw-shadow-sm tw-border tw-border-gray-300 tw-justify-center tw-items-center tw-gap-2 tw-inline-flex"
    >
      <div className="tw-text-gray-800 tw-text-sm tw-font-normal tw-font-['Lexend'] ltw-eading-tight">
        {getValues('showNoteForm')
          ? t('NoteForm/hideNote')
          : getValues('notes')?.length > 0 && (getValues('notes')[0]?.title != '' || getValues('notes')[0]?.description != '') && !getValues('showNoteForm')
          ? t('NoteForm/showNote')
          : t('NoteForm/addNote')}
      </div>
    </PSButton>
  );
};

export default AddNoteButton;
